import React from "react";
import { ClockCounterClockwise, MapPin, Pen } from "@phosphor-icons/react";
import { useState } from "react";
import PopUp from "../utils/PopUp";
import { toast } from "sonner";
import axios from "axios";

const CardHistoryLogistics = ({ cb }) => {
  const nameLogistics = cb.name_logistics;
  const uniqueCode = cb.unique_code_logistics;
  const last_user_name = cb.username;
  const status = cb.status;

  const {
    category,
    start_at,
    finish_at,
    report_logistics,
    report_activity,
    conditions_logistics,
    take_location_logistics_cords,
    take_location_logistics_name,
    finish_location_logistics_cords,
    finish_location_logistics_name,
  } = cb;

  return (
    <div>
      <div className="p-2.5 relative rounded-lg rounded-se-none shadow flex flex-col gap-2 bg-slate-50">
        <div className="flex border-b border-gray-400 justify-between">
          <p className="text-md  font-semibold">{nameLogistics}</p>
          <p className="text-md  font-semibold">{uniqueCode}</p>
        </div>
        <div className="flex gap-2">
          <div className="flex flex-col gap-2">
            <div
              className={`
                bg-green-700 text-white
                mt-1.5 flex flex-col rounded-lg gap-3`}
            >
              <p
                className={
                  "text-2xl h-full py-2 justify-center items-center flex flex-col font-bold "
                }
              >
                {cb.id}
              </p>
            </div>
            <div
              className={`
              flex-1
                ${
                  status === "Ready"
                    ? "bg-green-700 text-white"
                    : status === "Use"
                    ? "bg-orange-500 text-white"
                    : status === "Maintenance"
                    ? "bg-amber-400 text-white"
                    : status === "Broken"
                    ? "bg-red-700 text-white"
                    : "bg-green-200 text-green-600"
                }
                my-1.5 flex flex-col rounded-lg gap-3`}
            >
              <div
                className={`text-sm ${
                  status ? "text-green-600" : "text-green-600"
                } rounded-t-lg w-full px-3 font-bold text-center pt-2.5`}
              >
                {category}
              </div>
              <p
                className={
                  "text-2xl h-full py-2 justify-center items-center flex flex-col font-bold "
                }
              >
                {cb.id_logistics}
              </p>
            </div>
          </div>
          {/* BUILD TIME STATUS */}
          <div className="pt-1.5 px-1 flex justify-between gap-4 flex-col w-full">
            <div className="flex flex-col gap-4 justify-center w-full items-center">
              <div className="flex-1 w-full flex justify-around ">
                <p>{report_activity}</p>
                <p>Condiiton: {conditions_logistics}%</p>
              </div>
              <div className="flex-1 w-full gap-2 xl:gap-4 flex justify-around items-center">
                <div className=" px-4 py-3  text-white rounded-lg bg-green-700 ">
                  <p className="tracking-widest text-lg font-semibold text-center">
                    {getIndochinaTime(start_at)}
                  </p>
                  <p className=" whitespace-nowrap font-light  text-center text-xs">
                    {getIndochinaDate(start_at)}
                  </p>
                </div>
                <div className="w-4 h-1 xl:block bg-gray-400 hidden rounded absolute"></div>
                <div className=" px-4 py-3  text-white rounded-lg bg-green-700 ">
                  <p className="tracking-widest text-lg font-semibold text-center">
                    {getIndochinaTime(finish_at)}
                  </p>
                  <p className=" whitespace-nowrap font-light  text-center text-xs">
                    {getIndochinaDate(finish_at)}
                  </p>
                </div>
              </div>
              <div className="flex-1 w-full gap-2 xl:gap-4 grid grid-cols-2 -mt-2">
                <div className=" px-4 py-3 flex items-center justify-center flex-col  text-gray-500 bg-gray-300 rounded-lg">
                  <p className="text-xs text-center font-thin">
                    {take_location_logistics_cords}
                  </p>
                  <p className="font-light  text-center text-xs">
                    {take_location_logistics_name}
                  </p>
                </div>
                <div className=" px-4 py-3 flex items-center justify-center flex-col  text-gray-500 bg-gray-300 rounded-lg">
                  <p className="text-xs text-center font-thin">
                    {finish_location_logistics_cords}
                  </p>
                  <p className="font-light  text-center text-xs">
                    {finish_location_logistics_name}
                  </p>
                </div>
              </div>
            </div>
            <p className="w-full min-h-6 p-2 bg-green-200 text-green-600 text-xs rounded-lg">
                {report_logistics || '-'}
            </p>
            <div className="flex gap-1.5 justify-center px-2 items-center">
              <ClockCounterClockwise />
              <p className="font-semibold whitespace-nowrap text-xs">
                {last_user_name}
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CardHistoryLogistics;

function getIndochinaTime(prms) {
  const today = new Date(prms); // Waktu saat ini dalam UTC
  const utcOffset = today.getTimezoneOffset(); // Offset dalam menit
  const indochinaOffset = -420; // GMT+7 offset dalam menit

  // Menghitung selisih antara UTC dan Indochina
  const timeDifference = indochinaOffset - utcOffset;
  const indochinaTime = new Date(today.getTime() + timeDifference * 60 * 1000); // Mengonversi ke milidetik

  return indochinaTime.toLocaleString("id-ID", {
    timeZone: "Asia/Jakarta",
    hour: "2-digit",
    minute: "2-digit",
  }); // Format HH:mm
}
function getIndochinaDate(prms) {
  const today = new Date(prms); // Waktu saat ini dalam UTC
  const utcOffset = today.getTimezoneOffset(); // Offset dalam menit
  const indochinaOffset = -420; // GMT+7 offset dalam menit

  // Menghitung selisih antara UTC dan Indochina
  const timeDifference = indochinaOffset - utcOffset;
  const indochinaTime = new Date(today.getTime() + timeDifference * 60 * 1000); // Mengonversi ke milidetik

  return indochinaTime.toLocaleString("id-ID", {
    timeZone: "Asia/Jakarta",
    day: "numeric",
    month: "long",
    year: "numeric",
  }); // Format HH:mm
}
